<template>
  <div v-if="enabled" class="d-flex justify-end joku-draft">
    <v-btn small text color="primary" :loading="loading" :disabled="disabled || !site || !date" @click="draft">
      <v-icon left small>mdi-creation</v-icon>
      <span>{{ $t('daybook.jokuai.draft_situation') }}</span>
    </v-btn>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import daybookApi from '@/api/daybook';

/**
 * ALIT-557: joku.ai kokoaa työmaan tilanteesta päiväkirjaluonnoksen päivän tuntikirjausten
 * lisätiedoista. Backend hakee kirjaukset ja kutsuu joku.ai:ta; luonnos korvaa
 * Työmaan tilanne -kentän sisällön (@draft) ja käyttäjä tallentaa itse.
 */
export default {
  name: 'JokuSituationDraftButton',
  props: {
    site: { type: Object, default: null },
    work: { type: Object, default: null },
    date: { type: [Object, String], default: null },
    currentSituation: { type: String, default: null },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      enabled: false,
      loading: false,
    };
  },
  async created() {
    try {
      this.enabled = await daybookApi.situationDraftAvailable();
    } catch (e) {
      this.enabled = false;
    }
  },
  methods: {
    async draft() {
      this.loading = true;
      try {
        const tilanne = await daybookApi.draftSituation({
          siteId: this.site.id,
          siteName: this.site.name,
          workTitle: this.work ? this.work.title : null,
          workId: this.work ? this.work.id : null,
          date: dayjs(this.date).toISOString(),
          currentSituation: this.currentSituation || null,
        });
        this.$emit('draft', tilanne);
        this.$showSuccessNotification(this.$t('daybook.jokuai.draft_applied'));
      } catch (e) {
        const message = e && e.response && e.response.data && e.response.data.message;
        if (e && e.response && e.response.status === 422 && message && message.includes('no_entry_info')) {
          this.$showWarningNotification(this.$t('daybook.jokuai.no_entry_info'));
        } else {
          console.error(e);
          this.$showErrorNotification(this.$t('daybook.jokuai.unavailable'));
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.joku-draft {
  margin-top: -12px;
  margin-bottom: 8px;
}
</style>
